import { Button, Input, Space, Table, Modal, message, Tag, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import moment from 'moment';
import 'moment/locale/zh-cn';
import { ExclamationCircleFilled } from '@ant-design/icons';
import EUtils, { IButtonConfig } from "../../../utils/EUtils";
import ESearch, { IMoreConfig, ISearchConfig } from "../../../components/esearch/ESearch";
import InquiryMemberEdit from "./InquiryMemberEdit";

const { confirm } = Modal;

const InquiryMember = () => {
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState<any>({ pageIndex: 1, pageSize: 50 });
    const [searchValue, setSearchValue] = useState('');
    const [dataSource, setDataSource] = useState<any>([]);
    const [isOpen, setIsOpen] = useState(false);
    const [editRecord, setEditRecord] = useState<any>(null);

    const refESearch = useRef<any>(null);

    const columns: any[] = [
        {
            title: '会员账号', dataIndex: 'account', fixed: 'left', width: 120, ellipsis: true,
            render: (value: any, record: any) => {
                return <a onClick={() => { onOpen(2, record) }}>{value}</a>
            }
        }
        , { title: '会员名称', dataIndex: 'name', fixed: 'left', width: 120, ellipsis: true }
        , {
            title: '启用状态', dataIndex: 'isActive', width: 80, ellipsis: true,
            render: (text: any) => {
                return text ? <Tag color="green">启用</Tag> : <Tag color="red">禁用</Tag>
            }
        },
        { title: '手机号', dataIndex: 'tel', width: 80, ellipsis: true },
        {
            title: '会员类型', dataIndex: 'memberType', width: 80, ellipsis: true,
            render: (text: any, record: any) => {
                return <Tag color={record.memberTypeEnum == 2 ? 'orange' : 'green'}>{text}</Tag>
            }
        },
        { title: '业务员', dataIndex: 'salesName', width: 80, ellipsis: true },
        { title: '保险公司', dataIndex: 'companyName', width: 80, ellipsis: true },
        { title: '所属', dataIndex: 'enterpriseName', width: 80, ellipsis: true },
        { title: 'OpenID', dataIndex: 'openID', width: 80, ellipsis: true },
        { title: '备注', dataIndex: 'remark', width: 120, ellipsis: true },
        { title: '创建人', dataIndex: 'createBy', width: 80, ellipsis: true },
        {
            title: '创建时间', dataIndex: 'createTime', width: 150, ellipsis: true,
            render: (text: any) => (
                moment(text).format('YYYY-MM-DD hh:mm:ss')
            )
        },
        { title: '修改人', dataIndex: 'updateBy', width: 80, ellipsis: true },
        {
            title: '修改时间', dataIndex: 'updateTime', width: 150, ellipsis: true,
            render: (text: any) => (
                moment(text).format('YYYY-MM-DD hh:mm:ss')
            )
        },
        {
            title: '操作', align: 'center', width: 60, ellipsis: true, fixed: 'right',
            render(value: any, record: any, index: any) {
                var configs: IButtonConfig[] = [
                    {
                        name: '编辑', onClick: () => {
                            onOpen(1, record);
                        },
                    },
                    {
                        name: '启用', onClick: () => {
                            showActiveConfirm(record);
                        },
                        hidden: record.isActive
                    },
                    {
                        name: '禁用', onClick: () => {
                            showActiveConfirm(record);
                        },
                        hidden: !record.isActive,
                        danger: true
                    },
                    {
                        name: '解绑微信', onClick: () => {
                            onUnBindWX(record);
                        },
                        hidden: !record.openID,
                        danger: true
                    },
                ];
                return EUtils.InitButtons(configs);
            }
        }];

    const [scrollY, setScrollY] = useState("");
    const resize = () => setScrollY(EUtils.getTableScroll(82, ''));
    //页面加载完成后才能获取到对应的元素及其位置
    useEffect(() => {
        resize();
    }, [dataSource])

    useEffect(() => {
        loadData();
    }, [])
    useEffect(() => {
        loadData();
    }, [page])

    const loadData = () => {
        var params = {
            ...page,
            options: refESearch.current?.getOptions(),
        };
        Server.Post(URL.InquiryMember.GetInquiryMemberList, params).then((response: any) => {
            if (response.isSuccess) {
                setDataSource(response.data);
                setTotal(response.total);
            }
        });
    }

    const onOpen = (viewMode: number, record: any) => {
        setEditRecord({
            viewMode: viewMode,
            memberID: record?.memberID,
        })
        setIsOpen(true)
    }

    const onUnBindWX = (record: any) => {
        confirm({
            title: '解绑微信',
            icon: <ExclamationCircleFilled />,
            content: '会员[' + record.account + ']，确认要解绑微信?',
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = {
                    memberID: record.memberID,
                }
                Server.Post(URL.InquiryMember.UnBindWXInquiryMember, param).then((response: any) => {
                    if (response.isSuccess) {
                        message.success((record.isActive ? '禁用' : '启用') + '成功!');
                        loadData();
                    } else {
                        message.warn(response.returnMsg);
                    }
                })
            },
            onCancel() {
            },
        });
    };
    const showActiveConfirm = (record: any) => {
        confirm({
            title: record.isActive ? '禁用会员' : '启用会员',
            icon: <ExclamationCircleFilled />,
            content: '会员[' + record.account + ']，确认要' + (record.isActive ? '禁用' : '启用'),
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = {
                    memberID: record.memberID,
                    isActive: !record.isActive
                }
                Server.Post(URL.Member.SetActiveMember, param).then((response: any) => {
                    if (response.isSuccess) {
                        message.success((record.isActive ? '禁用' : '启用') + '成功!');
                        loadData();
                    } else {
                        message.warn(response.returnMsg);
                    }
                })
            },
            onCancel() {
            },
        });
    };

    const searchConfig: ISearchConfig[] = [
        { filedID: 'account', filedName: '会员账号' },
        { filedID: 'name', filedName: '会员名称' },
        { filedID: 'tel', filedName: '手机号' },
        { filedID: 'superiorMember', filedName: '上级代理' }
    ];

    const moreConfig: IMoreConfig[] = [
        {
            type: 'select', filedID: 'MemberTypeEnum', title: '会员类型', data: [
                { value: 2, label: '代理会员' },
                { value: 3, label: '保司会员' },
            ]
        },
        { type: 'select', filedID: 'SalesID', title: '业务员', dataUrl: URL.Sales.GetSalesOptions },
        { type: 'select', filedID: 'CompanyID', title: '保险公司', dataUrl: URL.Company.GetCompanyOptions },
        { type: 'select', filedID: 'IsActive', title: '启用状态', data: [{ value: true, label: '启用' }, { value: false, label: '禁用' }] },
        { type: 'dateTime', filedID: 'createTime', title: '注册时间' }
    ]

    return <div>
        <ESearch searchConfig={searchConfig} moreConfig={moreConfig} onLoad={loadData} resize={resize} ref={refESearch} />
        <div>
            <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', borderBottom: 'none', height: '45px', padding: '5px' }}>
                <span style={{ lineHeight: '30px', margin: '5px', fontWeight: 'bold' }}></span>
                <Space style={{ float: 'right' }}>
                    <Button type="primary" onClick={() => onOpen(0, null)}>开通会员</Button>
                </Space>
            </div>
            <Table size="small" bordered
                scroll={{ x: 'max-content', y: scrollY }}
                columns={columns} dataSource={dataSource} pagination={{
                    position: ['bottomRight'],
                    style: { margin: '5px' },
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: total,
                    showTotal: ((total) => {
                        return "共" + total + "条";
                    }),
                    current: page.pageIndex,
                    defaultCurrent: 20,
                    pageSize: page.pageSize,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    onShowSizeChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    }),
                    onChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    })
                }}
                summary={(pageData) => {
                    return <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={1} >
                                <Typography.Text>{'合计：' + (dataSource.length ?? 0)}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={1} ></Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={8} ></Table.Summary.Cell>
                            <Table.Summary.Cell index={3} colSpan={2}>
                                <Typography.Text></Typography.Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                }} />
        </div>
        <InquiryMemberEdit isOpen={isOpen} {...editRecord} setIsOpen={setIsOpen} loadData={loadData} />
    </div>
}
export default InquiryMember;